export default "__VITE_ASSET__DBda7ibt__"